/*
 * @Description: 
 * @Author: liangziyao
 * @Date: 2021-09-01 10:13:53
 */

// 导入图片
import '../img/award/default-award.png';
import '../img/award/douluo-1.png';
import '../img/award/douluo-2.png';
import '../img/award/douluo-3.png';
import '../img/award/douluo-4.png';
import '../img/award/douluo-5.png';
import '../img/award/douluo-6.png';
import '../img/award/douluo-7.png';
import '../img/award/douluo-8.png';
import '../img/award/qiji-1.png';
import '../img/award/qiji-3.png';
import '../img/award/qiji-4.png';
import '../img/award/qiji-5.png';
import '../img/award/qiji-6.png';
import '../img/award/qiji-8.png';
import '../img/award/jianghu-1.png';
import '../img/award/jianghu-2.png';
import '../img/award/jianghu-3.png';
import '../img/award/jianghu-4.png';
import '../img/award/jianghu-5.png';
import '../img/award/jianghu-6.png';
import '../img/award/jianghu-7.png';
import '../img/award/jianghu-8.png';
import '../img/award/jianghu-9.png';
import '../img/award/jianghu-10.png';


export default {
  // 破局：三國終章
  "53": {
    name: '破局：三國終章',
    sign_1: {
      name: '九九問候禮',
      content: '輜重自選箱x5、快速行軍x5、米酒x5'
    },
    sign_2: {
      name: '九九慶賀禮',
      content: '伐木令x5、星晷x5、米酒x5'
    },
    sign_3: {
      name: '九九久久禮',
      content: '輜重自選箱x5、挖礦令x5、賬本x5'
    },
    sign_total: {
      name: '九九累計禮',
      content: '米酒x10、輜重自選箱x10、星晷x10'
    },
    lottery_53_1: {
      name: '沙場見面禮',
      content: '米酒x30'
    },
    lottery_53_2: {
      name: '沙場初級禮',
      content: '號角x15'
    },
    lottery_53_3: {
      name: '沙場中級禮',
      content: '挖礦令x10'
    },
    lottery_53_4: {
      name: '沙場高級禮',
      content: '賬本x15'
    },
    lottery_53_5: {
      name: '沙場特級禮',
      content: '急速行軍x20'
    },
    lottery_53_6: {
      name: '沙場征戰禮',
      content: '輜重自選箱x20'
    },
    lottery_53_7: {
      name: '謝謝參與',
      content: ''
    },
    lottery_53_8: {
      name: '滿5000-1000抵扣券',
      content: '滿5000-1000抵扣券'
    },
    lottery_53_9: {
      name: '滿300-300抵扣券',
      content: '滿300-300抵扣券'
    },
    lottery_53_10: {
      name: '滿2000-500抵扣券',
      content: '滿2000-500抵扣券'
    },
  },
  // 創世破曉
  "17": {
    name: '創世破曉',
    sign_1: {
      name: '99一日簽到禮包',
      content: '3倍經驗藥水'
    },
    sign_2: {
      name: '99二日簽到禮包',
      content: '688氪菲金石禮包'
    },
    sign_3: {
      name: '99三日簽到禮包',
      content: '3倍經驗藥水'
    },
    sign_total: {
      name: '99累計簽到禮包',
      content: '50綁鑽'
    },
    lottery_17_1: {
      name: '99節初級禮包',
      content: '30綁鑽'
    },
    lottery_17_2: {
      name: '99節幸運禮包',
      content: '5倍經驗藥水'
    },
    lottery_17_3: {
      name: '99節驚喜禮包',
      content: '極品道具尋寶令'
    },
    lottery_17_4: {
      name: '99節超級禮包',
      content: '8倍經驗藥水'
    }
  },
  // 斗羅大陸 有img
  "44": {
    name: '斗羅大陸',
    sign_1: {
      name: '99首日簽到禮包',
      content: '2.5倍經驗藥水*1、鎢鋼*5、魂幣*300000',
      img: 'douluo-1.png'
    },
    sign_2: {
      name: '99二日簽到禮包',
      content: '中階致命魂石*3、鎢鋼*5、魂幣*300000',
      img: 'douluo-2.png'
    },
    sign_3: {
      name: '99三日簽到禮包',
      content: '蒜香腸*1、紅玉*5、魂幣*300000',
      img: 'douluo-3.png'
    },
    sign_total: {
      name: '99累計簽到禮包',
      content: '坐騎精通石*1、紅玉*10、魂幣*600000',
      img: 'douluo-4.png'
    },
    lottery_44_1: {
      name: '99節初級禮包',
      content: '珍稀材料選擇禮包*1',
      img: 'douluo-5.png'
    },
    lottery_44_2: {
      name: '99節幸運禮包',
      content: '粉紅腸*1',
      img: 'douluo-6.png'
    },
    lottery_44_3: {
      name: '99節驚喜禮包',
      content: '中階致命魂石*3',
      img: 'douluo-7.png'
    },
    lottery_44_4: {
      name: '99節超級禮包',
      content: '鎢鋼*5',
      img: 'douluo-8.png'
    }
  },
  // 江湖大夢 有img
  "28": {
    name: '江湖大夢',
    sign_1: {
      name: '九九首日禮',
      content: '白虎圖*1、肝膽照*1、銅錢*1000000',
      img: 'jianghu-1.png'
    },
    sign_2: {
      name: '九九二日禮',
      content: '染流螢*2、青龍圖*1、銀票*10000',
      img: 'jianghu-2.png'
    },
    sign_3: {
      name: '九九三日禮',
      content: '訴冰心體驗券*1、玄武圖*1、銀兩*10000',
      img: 'jianghu-3.png'
    },
    sign_total: {
      name: '累計登入禮',
      content: '春晚留念寶箱*1、朱雀圖*1',
      img: 'jianghu-4.png'
    },
    lottery_28_1: {
      name: '江湖見面禮',
      content: '染流螢*1、銅錢*10000',
      img: 'jianghu-5.png'
    },
    lottery_28_2: {
      name: '江湖初級禮',
      content: '肝膽照*1、銅錢*100000',
      img: 'jianghu-6.png'
    },
    lottery_28_3: {
      name: '江湖中級禮',
      content: '長相守*1、銅錢*1000000',
      img: 'jianghu-7.png'
    },
    lottery_28_4: {
      name: '江湖高級禮',
      content: '鴛鴦錦*1、銅錢*1000000',
      img: 'jianghu-8.png'
    },
    lottery_28_5: {
      name: '江湖特級禮',
      content: '陰陽造化丹*1、四象圖*1',
      img: 'jianghu-9.png'
    },
    lottery_28_6: {
      name: '九九節賀禮',
      content: '訴冰心*1',
      img: 'jianghu-10.png'
    }
  },
  // 叫我大掌櫃
  "52": {
    name: '叫我大掌櫃',
    sign_1: {
      name: '99首日簽到禮包',
      content: '抽獎券*3、分鐘卡*30、活力丹*50、聲望符*1'
    },
    sign_2: {
      name: '99二日簽到禮包',
      content: '抽獎券*3、小資質丹*5、木梳*10、胭脂*10、產物卡*5、珍寶箱*15'
    },
    sign_3: {
      name: '99三日簽到禮包',
      content: '抽獎券*6、珍獸果*5、市井手記*20、隨機書籍*50、算盤*10、卓越突破箱*1'
    },
    sign_total: {
      name: '99累計簽到禮包',
      content: '抽獎券*6、隨機批文*1、自選寶印碎片*1、商鋪圖紙*5、精力丹*5、體力丹*5'
    },
    lottery_52_1: {
      name: '99節初級禮包',
      content: '小資質丹*5、分鐘卡*40、活力丹*50、蠱惑卡*1'
    },
    lottery_52_2: {
      name: '99節幸運禮包',
      content: '卓越突破箱*1、體力丹*5、精力丹*5、活力丹*50、市井手記*30、隨機書籍*50'
    },
    lottery_52_3: {
      name: '99節驚喜禮包',
      content: '小時卡*1、募工金牌*20、募工銀牌*40、募工銅牌*80、產物卡*15、算盤*20'
    },
    lottery_52_4: {
      name: '99節超級禮包',
      content: '自選寶印碎片*1、珍獸果*5、珍寶箱*15、百業劄記*30、木梳*10、胭脂*15'
    },
    lottery_52_5: {
      name: '99節豪華禮包',
      content: '錢莊圖紙*5、商鋪圖紙*3、病人手冊*10、銅簪*5、香囊*10、許願石*5'
    },
    lottery_52_6: {
      name: '99節富貴禮包',
      content: '門客殘帖*1、殘破綴玉*5、浮光錦*1、天香絹*1、抽獎券*18、銀耳環*3'
    }
  },
  // 	奇蹟MU：跨時代 有img
  "51": {
    name: '奇蹟MU：跨時代',
    sign_1: {
      name: 'G妹99節簽到禮包',
      content: '防禦神兵（初級）*3，生命神兵（初級）*3，攻擊神兵（初級）*3',
      img: 'qiji-1.png'
    },
    sign_2: {
      name: 'G妹99節簽到禮包',
      content: '祝福寶石 *2，靈魂寶石 *2，瑪雅寶石 *5',
      img: 'qiji-1.png'
    },
    sign_3: {
      name: 'G妹99節簽到禮包',
      content: '進化寶石 *3，生命神兵（初級）*2，攻擊神兵（初級）*2',
      img: 'qiji-3.png'
    },
    sign_total: {
      name: 'G妹99節簽到禮包',
      content: '生命寶石 *5，防禦神兵（初級）*2，生命神兵（初級）*2，攻擊神兵（初級）*2',
      img: 'qiji-4.png'
    },
    lottery_51_1: {
      name: 'G妹99節扭蛋禮包',
      content: '生命寶石 *10，百煉精鋼 *1，靈魂寶石*8，防禦神兵（中級）*5',
      img: 'qiji-5.png'
    },
    lottery_51_2: {
      name: 'G妹99節扭蛋禮包',
      content: '百煉精鋼 *1，進化寶石 *3，靈魂寶石 *5',
      img: 'qiji-6.png'
    },
    lottery_51_3: {
      name: 'G妹99節扭蛋禮包',
      content: '防禦神兵（中級）*2，生命神兵（中級）*2，瑪雅寶石 *5',
      img: 'qiji-6.png'
    },
    lottery_51_4: {
      name: 'G妹99節扭蛋禮包',
      content: '進化寶石 *2，靈魂寶石 *2，瑪雅寶石 *2',
      img: 'qiji-8.png'
    },
    lottery_51_5: {
      name: 'G妹99節扭蛋禮包',
      content: '靈魂寶石 *2，瑪雅寶石	*2，攻擊神兵（初級）*2',
      img: 'qiji-8.png'
    }
  }
}
